// @ts-nocheck
/**
 * printExport.ts
 * 印刷・PDF・PNG エクスポート関連メソッド
 * App.vue から切り出し
 */

import {
  fncPngDl,
  fncPdfDl,
  fncPdfDlTiled,
} from '@/js/downLoad'
import { consumeToken } from '@/js/tokenService'
import store from '@/store'

type VM = any

export function pdfDl(vm: VM) {
  vm.openPdfPrintOptionsDialog()
}

export async function executePdfDl(vm: VM) {
  const tokenResult = await consumeToken('export_pdf')
  if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return
  if (vm.$store.state.printTileEnabled) {
    fncPdfDlTiled(vm.s_printMap)
    return
  }
  fncPdfDl(vm.s_printMap)
}

export function openPdfPrintOptionsDialog(vm: VM) {
  try {
    const savedEnabled = localStorage.getItem('printTileEnabled')
    if (savedEnabled !== null) {
      vm.printTileEnabledLocal = JSON.parse(savedEnabled)
    } else {
      vm.printTileEnabledLocal = !!vm.$store.state.printTileEnabled
    }
    const savedSize = localStorage.getItem('printTileSize')
    if (savedSize !== null) {
      vm.printTileSizeLocal = JSON.parse(savedSize)
    } else {
      vm.printTileSizeLocal = vm.$store.state.printTileSize || 'a4'
    }
  } catch (e) {
    vm.printTileEnabledLocal = !!vm.$store.state.printTileEnabled
    vm.printTileSizeLocal = vm.$store.state.printTileSize || 'a4'
  }
  vm.dialogForPdfPrintOptions = true
}

export function confirmPdfDl(vm: VM) {
  vm.$store.state.printTileEnabled = !!vm.printTileEnabledLocal
  vm.$store.state.printTileSize = vm.printTileSizeLocal || 'a4'
  try {
    localStorage.setItem('printTileEnabled', JSON.stringify(vm.$store.state.printTileEnabled))
    localStorage.setItem('printTileSize', JSON.stringify(vm.$store.state.printTileSize))
  } catch (_) {}
  vm.dialogForPdfPrintOptions = false
  vm.executePdfDl()
}

// === PDF Pro 機能 START ===
// pdfDlPro () {
//   fncPdfDlPro(this.s_printMap)
// },
// === PDF Pro 機能 END ===
export function pngDl0(vm: VM) {
  fncPngDl(vm.s_printMap)
}

export function print() {
  // 印刷ダイアログ表示
  setTimeout(() => {
    window.print()
  }, 200)
}

export function s_printMap01(vm: VM) {
  vm.s_printMap = 'map01'
  vm.stopPrintSync()
  vm.stopMapSync()
  vm.mapSize.map01.width = '100%'
  vm.mapSize.map01.height = '100%'
}

export function s_printMap02(vm: VM) {
  vm.s_printMap = 'map02'
  vm.stopPrintSync()
  vm.stopMapSync()
  vm.addOsmToMap02()
  vm.mapSize.map02.width = '100%'
  vm.mapSize.map02.height = '100%'
}

export function s_printMap03(vm: VM) {
  vm.s_printMap = 'map03'
  vm.addOsmToMap02()
  // リアクティブにmapSizeを更新（方向に応じて）
  vm.applyPrintMap03Layout()
  // 既存の同期を停止
  vm.stopPrintSync()
  vm.stopMapSync()
  setTimeout(() => {
    const map01 = vm.$store.state.map01
    const map02 = vm.$store.state.map02
    if (!map01 || !map02) return
    // モードが変わっていたら中止
    if (vm.s_printMap !== 'map03') return
    // マップのリサイズ
    map01.resize()
    map02.resize()
    // map02をmap01に合わせる（初期同期）
    const zoomOffset = vm.printZoomOffset || 0
    map02.jumpTo({
      center: map01.getCenter(),
      zoom: map01.getZoom() - zoomOffset,
      bearing: map01.getBearing(),
      pitch: map01.getPitch()
    })
    // 印刷用シンプル同期を開始
    vm.startPrintSync()
  }, 200)
}

// 印刷2画面用のシンプルな双方向同期（re-entrancyガード付き）
export function startPrintSync(vm: VM) {
  vm.stopPrintSync()
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (!map01 || !map02) return
  let locked = false
  const syncToMap02 = () => {
    if (locked) return
    locked = true
    const zoomOffset = vm.printZoomOffset || 0
    map02.jumpTo({
      center: map01.getCenter(),
      zoom: map01.getZoom() - zoomOffset,
      bearing: map01.getBearing(),
      pitch: map01.getPitch()
    })
    locked = false
  }
  const syncToMap01 = () => {
    if (locked) return
    locked = true
    const zoomOffset = vm.printZoomOffset || 0
    map01.jumpTo({
      center: map02.getCenter(),
      zoom: map02.getZoom() + zoomOffset,
      bearing: map02.getBearing(),
      pitch: map02.getPitch()
    })
    locked = false
  }
  map01.on('move', syncToMap02)
  map02.on('move', syncToMap01)
  vm._printSyncHandlers = { syncToMap02, syncToMap01 }
}

export function stopPrintSync(vm: VM) {
  if (!vm._printSyncHandlers) return
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (map01) map01.off('move', vm._printSyncHandlers.syncToMap02)
  if (map02) map02.off('move', vm._printSyncHandlers.syncToMap01)
  vm._printSyncHandlers = null
}

// 印刷2画面時のmapSizeをリアクティブに設定
export function applyPrintMap03Layout(vm: VM) {
  let dir = vm.titleDirection
  if (dir === 'vertical') dir = 'a4-vertical'
  if (dir === 'horizontal') dir = 'a4-horizontal'
  if (dir === 'a4-vertical' || dir === 'a3-vertical') {
    // 縦向き: 上下配置
    vm.mapSize.map01.width = '100%'
    vm.mapSize.map01.height = '50%'
    vm.mapSize.map02.width = '100%'
    vm.mapSize.map02.height = '50%'
  } else {
    // 横向き: 左右配置
    vm.mapSize.map01.width = '50%'
    vm.mapSize.map01.height = '100%'
    vm.mapSize.map02.width = '50%'
    vm.mapSize.map02.height = '100%'
  }
}

// 詳細/俯瞰モード: ズームオフセットを設定
export function setPrintZoomOffset(vm: VM, offset) {
  vm.printZoomOffset = offset
  // 2画面モードでなければ切り替え
  if (vm.s_printMap !== 'map03') {
    vm.s_printMap03()
  } else {
    // 既に2画面モードの場合、即座にオフセットを適用
    const map01 = vm.$store.state.map01
    const map02 = vm.$store.state.map02
    if (map01 && map02) {
      map02.jumpTo({
        center: map01.getCenter(),
        zoom: map01.getZoom() - offset,
        bearing: map01.getBearing(),
        pitch: map01.getPitch()
      })
    }
  }
}

